import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mohit/Documents/Github/cp4d-managed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Purdue study found that switching from light mode to dark mode at 100% brightness saves an average of 39%-47% battery power.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.purdue.edu/newsroom/releases/2021/Q3/dark-mode-may-not-save-your-phones-battery-life-as-much-as-you-think,-but-there-are-a-few-silver-linings.html"
      }}>{`Source`}</a></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "966px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "114.58333333333334%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAABYlAAAWJQFJUiTwAAADnklEQVQ4y61US08bVxQee2zw4PfYYWb8dmxsjwPOAK4fBaTEwR7bBfFokSoEUo2rCtRNi1SRVpW6ABUWiAilImogCUlYxOmy23Tbv/VV51pj7NKqD2VxdM+ce+435/vOuZfjOA5/NpPJ1PMdDgd4nme+xWLpxc1m81/6nHF4e3sbnU4HBwcH2Nvbw+npKXZ3d1m8Xq/j8PAQDx9+i7OzM+zv7+P4+JjZ0dERTk5OMDw8bIB2kXVdR6vVwubmJpaXl9FqfQZdryEajSKXy6Hd3sLq6irLWVtbY7axsYH19XUWN1hwhtNut/Hu3W949OgUL15c4unTc5yfX+D16yu8edPBxcVzPHnyMy4vX7L9Z8+e4/Hjn/D27S+4urq6BjQoUxX01wcP5hlFXa+jVquhWq2y73q9wfxms8l8is3PV7G4uIhGo9Gv+2AT3oNdd5bKpo79H7sB+E/j8x/2u3NEbbfZbMyGhoZuJNJ+MBhEJBJBOByGJEnw+XyQZRmKomBkZOQaMBAIMHFJcGoEWTabZQcNOjTUlUoFOzs7bLSoKaqqwu/3sx/Z7fZrQKfTyTbT6TSSySRSqRQymQzGx8dZxZRDVU9MTGBubg6FQgEzMzMolUosj/IHAD0eD8ofllkCHaC1WCyiXC5jbGysVyHFl5aWUK3RuCwwRisrK8jn84OUeTMPwSrAbrPD4XSwTapaEISenrRSNXRY0zTc1SYxNTWFyUkN8Xh8ENB1ywXtIw3hbOhGI4wHgcBlRWaa+b1+3I4o8Hj9EEXSMDBIWQyL0Hdr0HQNiqSwZrjdbni9XvbaGIAkfkBWMPvNffz6cgGdvTKCsRCLOxz9Gga9KG/NIHU/DcEmsL8RRQI1miKMCJBECXcqWaxefoJwQMTv6wlsaVG4pABc/YAJ/zB+XApjMn4LHGcGbzazoSUdjWeJAJVRBbdzSXz6agGxz7/Ad+MVNDxOiJEInP2Uo6IV3zdl5MckcCYLeL4LSJQNsRnlUBCjPhkTlTjufPkVfLMfQx4VEQqFBzVMSnb8sBBCSQ3A4RZZhTTQBEhABiDdDjWTQWG6hHvFElaaOqY/KECSpZ7WDDDiteDrWQEZ2QaOt4I3d+8ozacBSFoGw0FEU1HE41Hk0jHEEwkkAwFE6Or1V/hvjABjiRjUaRXhUBD38iqi0QiKqoq7mTSEfkAT3QRzd/07QKvVCrfLDbfTzbrvFn2Mgcfng1cU+x8U7n0+rvgDLJdus7kmdm8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Why-Dark",
        "title": "Why-Dark",
        "src": "/cp4d-managed/static/5f32bcb7d0bee587ca20a198f31c69fa/d65e0/why-dark.png",
        "srcSet": ["/cp4d-managed/static/5f32bcb7d0bee587ca20a198f31c69fa/7fc1e/why-dark.png 288w", "/cp4d-managed/static/5f32bcb7d0bee587ca20a198f31c69fa/a5df1/why-dark.png 576w", "/cp4d-managed/static/5f32bcb7d0bee587ca20a198f31c69fa/d65e0/why-dark.png 966w"],
        "sizes": "(max-width: 966px) 100vw, 966px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      